import MessageTable from "@/app/app-shared/message/table";

export default function FollowUpPage() {
  return <MessageTable isAgency={true} />;
}
